import React, { useState } from 'react';
import DownArrow from '../../../../../assets/images/hardware-inclusive/down-arrow.svg';
import RightArrow from '../../../../../assets/images/hardware-inclusive/right-arrow.svg';
import EcoProButton from '../../../../shared/button/button';
import './PrinterCheckoutBar.css'
import { Accordion, Card, useAccordionButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getSelectPrinterHeaderTranslation } from '../../../../../utils/HardwareInclusive/HardwareInclusive';

function CustomToggle({ eventKey, isOpen, disabled }) {
    const decoratedOnClick = useAccordionButton(eventKey);
    const { t } = useTranslation(["translation"])
    return (
        <button
            type="button"
            className="hardware-inclusive-printer-btn view-details"
            id={`1`}
            onClick={decoratedOnClick}
            disabled={disabled}
        >
            <span className='toggle-text'>{isOpen ? t("HARDWARE_SIGNUP.BUTTON.HIDE_DETAILS") : t("HARDWARE_SIGNUP.BUTTON.VIEW_DETAILS")}</span>
            <img
                src={DownArrow}
                alt="show checkout details"
                className={`printer-checkout-bar-img ${isOpen ? "upArrowImg" : "downArrowImg"
                    }`}
            />
        </button>
    );
}

const PrinterCheckoutBar = (props) => {
    const { printerTypeId, monthlyPaymentPrice, dueTodayPrice, hardwareFeatureFlags, formattedSelections, disabled, handleCheckout } = props
    const [activeKey, setActiveKey] = useState(null);
    const { t } = useTranslation(["translation"])


    const hardwarePlanMapping = {
        deviceType: "DEVICE_TYPE",
        hardwarePrinterType: "HARDWARE_TYPE",
        monthlyPageAllowance: "SUPPLY_PLAN",
        planLength: "PLAN_LENGTH",
        typeOfPrinting: "PRINT_OUTPUT"
    };


    return (
        <>
            <div className='printer-checkout-bar-container'>
                <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                    <Card>
                        <Card.Header>
                            <div className="printer-checkout-bar-wrapper">
                                <div className='printer-checkout-bar-desktop'>
                                    <div className='printer-title'>{getSelectPrinterHeaderTranslation(printerTypeId, hardwareFeatureFlags)}</div>
                                    <div className='pcb-price-wrapper'>
                                        {!disabled &&
                                            <div className="pcb-price">
                                                <div className="price-block">
                                                    <span className="price-amount">{dueTodayPrice}</span>
                                                    <span className="price-label">{t("PAYMENT_SUMMARY.DUE_TODAY_TXT")}</span>
                                                </div>
                                                <div className="price-block">
                                                    <span className="price-amount">{monthlyPaymentPrice}</span>
                                                    <span className="price-label">{t("CUSTOMER_WEB.SELECT_PLAN.PER_MONTH")}</span>
                                                </div>
                                            </div>}
                                        <CustomToggle
                                            eventKey="0"
                                            isOpen={activeKey === "0"}
                                            disabled={disabled}
                                        />
                                    </div>
                                </div>
                                <div className='printer-checkout-bar-mobile'>
                                    <div className='pcb-price-wrapper'>
                                        <div className='printer-title'>{getSelectPrinterHeaderTranslation(printerTypeId, hardwareFeatureFlags)}</div>
                                        {!disabled &&
                                            <div className="pcb-price">
                                                <div className="price-block">
                                                    <span className="price-amount">{dueTodayPrice}</span>
                                                    <span className="price-label">{t("PAYMENT_SUMMARY.DUE_TODAY_TXT")}</span>
                                                </div>
                                                <div className="price-block">
                                                    <span className="price-amount">{monthlyPaymentPrice}</span>
                                                    <span className="price-label">{t("CUSTOMER_WEB.SELECT_PLAN.PER_MONTH")}</span>
                                                </div>
                                            </div>}
                                    </div>
                                    <CustomToggle
                                        eventKey="0"
                                        isOpen={activeKey === "0"}
                                        disabled={disabled}
                                    />
                                </div>
                            </div>
                        </Card.Header>
                        {!disabled &&
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <div className='printer-checkout-bar-details'>
                                        <div className='pcd-selected-data-wrapper'>
                                            {Object.entries(hardwarePlanMapping).map(([key, label]) => (
                                                formattedSelections[key] && (<div key={key}>
                                                    <div></div>
                                                    <div className='label'>{t(`HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.${label}.HEADER`)}</div>
                                                    <div className='data-row'>
                                                        <div className='data'>
                                                            {formattedSelections[key]}
                                                        </div>
                                                        {(key === "hardwarePrinterType" || key === "monthlyPageAllowance") && (
                                                            <div className="data-price">
                                                                {key === "hardwarePrinterType"
                                                                    ? `+ ${dueTodayPrice}`
                                                                    : `+ ${monthlyPaymentPrice}`}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                )
                                            ))}
                                        </div>
                                        <EcoProButton
                                            cname="pcb-checkout"
                                            btnID={`1`}
                                            onBtnClick={() => handleCheckout()}
                                        >
                                            {t("HARDWARE_SIGNUP.BUTTON.CHECKOUT")}
                                            <img
                                                src={RightArrow}
                                                alt="show checkout details"
                                                className="printer-checkout-bar-img"
                                            />
                                        </EcoProButton>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>}
                    </Card>
                </Accordion>
            </div>
        </>
    );
};

export default PrinterCheckoutBar;